module.exports = __webpack_public_path__ + "assets/img/0e3f24eccc658b81286dfff98c834d58.svg";